export const CHART_COLOURS = [
  '#0d6efd',
  '#1f7a4d',
  '#6c757d',
  '#ffc107',
  '#dc3545',
  '#6610f2',
  '#20c997',
  '#fd7e14',
]
